var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeamsSettings = function SvgTeamsSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "currentColor",
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.4 17c.88 0 1.6.72 1.6 1.6v4.8c0 .88-.72 1.6-1.6 1.6H8.6A1.6 1.6 0 0 1 7 23.4v-4.8c0-.88.72-1.6 1.6-1.6zm10 0c.88 0 1.6.72 1.6 1.6v4.8c0 .88-.72 1.6-1.6 1.6h-4.8a1.6 1.6 0 0 1-1.6-1.6v-4.8c0-.88.72-1.6 1.6-1.6zm-10-10c.88 0 1.6.72 1.6 1.6v4.8c0 .88-.72 1.6-1.6 1.6H8.6A1.6 1.6 0 0 1 7 13.4V8.6C7 7.72 7.72 7 8.6 7zm10 0c.88 0 1.6.72 1.6 1.6v4.8c0 .88-.72 1.6-1.6 1.6h-4.8a1.6 1.6 0 0 1-1.6-1.6V8.6c0-.88.72-1.6 1.6-1.6z"
  })));
};
export default SvgTeamsSettings;